import { render } from "./PinModalAdd.vue?vue&type=template&id=64cd758f&scoped=true"
import script from "./PinModalAdd.vue?vue&type=script&lang=js"
export * from "./PinModalAdd.vue?vue&type=script&lang=js"

import "./PinModalAdd.vue?vue&type=style&index=0&id=64cd758f&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-64cd758f"

export default script